import { TFunction } from "i18next";
import { ROUTE_PATH, TAudience, TCategory } from "../../utilities/navigation";
import { NavigateFunction, useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { WEBSITE_BASE_URL } from "../../types/constants";

const getCategoryProps = (t: TFunction, target: TAudience, asCareer?: boolean, navigate?: NavigateFunction) => {
    // const categories = t('categories', { context: target, returnObjects: true }) as any;//not formatting nested translation
    const categoriesKey = `categories_${target}`;
    const memberKey = `careers.members_${target}`;
    return {
        title: t(!!asCareer ? `${memberKey}.title` : `${categoriesKey}.title`),
        description: t(!!asCareer ? `${memberKey}.content` : `${categoriesKey}.description`),
        categories: (t(`${categoriesKey}.list`, { returnObjects: true }) as Array<{ title: string, description: string, image: string, type: string }>)
            .map((category) => ({
                ...category,
                onClick: () => !!asCareer ? window.open(WEBSITE_BASE_URL + ROUTE_PATH.buildTestimonials(target, category.type as TCategory), '_blank') : navigate?.(ROUTE_PATH.buildTestimonials(target, category.type as TCategory))
            }))
    };
}

export const useGetCategorySectionProps = (audience: TAudience, asCareer?: boolean) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    return getCategoryProps(t, audience, asCareer, navigate);
}

export const getCategoryInfo = (t: TFunction, audience: TAudience, category: TCategory, asCareer?: boolean) => {
    return getCategoryProps(t, audience, asCareer).categories.find(cat => cat.type === category)
}